module.exports = __webpack_public_path__ + "static/media/chat-dark.a67d89c7.svg";